import { useState, useEffect } from "react";
import { Steps, Divider } from "antd";

import {
  Messages,
  Notify,
  openNotification,
  util
} from '@seims/shared';

import {
  isAuthorizedRole,
} from "@seims/shared/src/security";

import api from "../../services/dataMigrationService";
import { recordError } from "../../utils/logService";
import UploadProgress from "./UploadProgress";
import StartUpload from "./StartUpload";
import Preview from "./Preview";
import Feedback from "./Feedback";
import { programmes } from '../../utils/functions/apiConstants';


export default function DataUpload() {

    const [uploadedFile, setUploadedFile] = useState({});
    const [current, setCurrent] = useState(0);
    const [progress, setProgress] = useState(0);
    const [feedbackData, setFeedbackData] = useState({});
    const [loading, setLoading] = useState(false);
    const [recordLimit, setRecordLimit] = useState(1000);
    const [columnHeaders, setColumnHeaders] = useState([]);

    //! We need to implement a function that determines module based on the role logged in, or we can receive this from the backend
    const [moduleName, setModuleName] = useState("");
    
    const { Step } = Steps;

  useEffect(() => {
    getCurrentModule();
    if (moduleName) {
      getRecordLimit();
      getColumnHeaders();
    }
  }, [moduleName]);

    const updateStatus = (status) => {
      setCurrent(status);
    };

    const getCurrentModule = () => {
      if (isAuthorizedRole(["NYS_DATA_UPLOADER"])) 
      {
        setModuleName(programmes.find(c=>c.key === 'nys-programme').key);
      }
      else if (isAuthorizedRole(["EVENTS_DATA_UPLOADER"])) 
      {
        setModuleName(programmes.find(c=>c.key === 'events-tracker').key);
      }
      else if (isAuthorizedRole(["CS_DATA_UPLOADER"])) 
      {
        setModuleName(programmes.find(c=>c.key === 'citizen-science').key);
      }
      else
      {
        setModuleName(programmes.find(c=>c.key === 'volunteer-scientist').key);
      }
    }

    const getColumnHeaders = async ()=> {
        try {
          if(isAuthorizedRole(["NYS_DATA_UPLOADER"])){
           const response = await api.getColumnHeaders(moduleName);
           if (response && response.status === 200) {
             const { data } = response;
             setColumnHeaders(data);
           } else {
             setColumnHeaders([]);
           }
          }else if (isAuthorizedRole(["EVENTS_DATA_UPLOADER"])){
            const cHeader = [
              {
                key:1,
                value:"Header Group"
              },
              {
                key:2,
                value:"Header Name"
              },
              {
                key:3,
                value:"Value"
              },
            ]
            setColumnHeaders(cHeader);

          }
          
        } catch (error) {
          recordError(error);
        }
    
      }
  
    const trackProgress = (progress) => {
      setProgress(progress);
    };
  
    const handleFileSubmit = async () => {
      try {
        setLoading(true);
        setProgress(1);
        var msg;
 
         
        const response = await api.uploadFile(uploadedFile, moduleName, trackProgress);
  
        if (response.status === 200 || response.status === 201) {
          const { data } = response;
          setFeedbackData(data);
          setCurrent(3);
          setProgress(1);
          setLoading(false);
  
          return;
        }
  
        msg = util.parseMessage(Messages.FILEUPLOAD_FAILURE, "File");
        openNotification("File Upload", msg, Notify.ERROR);
      } catch (error) {
        recordError(error);
        // Currently backend is responding with 400, we need to standardise this so that it matches across
        if (error.response.status === 406) {
          msg = util.parseMessage(error.response?.data?.message, "File");
          openNotification("File Upload Failed", msg, Notify.ERROR);
            
          setLoading(false);
          setProgress(0);
          return;
        }
  
        msg = util.parseMessage(Messages.FILEUPLOAD_FAILURE, "File");
        openNotification("File Upload", msg, Notify.ERROR);
  
        setLoading(false);
        setProgress(0);
      }
    };
  
    const getRecordLimit = async () => {
      try {
        const response = await api.getRecordLimit(moduleName);
  
        if (response && response.status === 200) {
          const { data } = response;
          setRecordLimit(data.totalRecords);
        }
        else {
          setRecordLimit(1000);
        }
      } catch (error) {
        recordError(error);
      }
    };
    const Nystitle = "NYS Data Upload";
    const Eventstitle = "Events Data Upload";
    const Partnertitle = "Partner Data Upload";
    const CitizenStitle = "Citizen Science Data Upload";
    const subTitle = "Select file to upload for processing";
    return (
      <div className="content">
        {
          isAuthorizedRole(["NYS_DATA_UPLOADER"]) &&
          <h1 className="center-align">{Nystitle}</h1>
        }
           {
          isAuthorizedRole(["EVENTS_DATA_UPLOADER"]) &&
          <h1 className="center-align">{Eventstitle}</h1>
        }      {/* {
          isAuthorizedRole(["SAASTA_OFFICIAL"]) &&
          <h1 className="center-align">{Eventstitle}</h1>
        } */}
            <p className="sub-title center-align">{subTitle}</p>

            <Steps current={current}>
                <Step title="Start"></Step>
                <Step title="Preview"></Step>
                <Step title="Upload"></Step>
                <Step title="Results"></Step>
            </Steps>
            <Divider />
            <div>
                {current === 0 ? (
                    <StartUpload
                        setUploadedFiles={setUploadedFile}
                        setProgressState={updateStatus}
                    />
                ) : current === 1 ? (
                    <Preview
                        file={uploadedFile}
                        setProgressState={updateStatus}
                        onFileSubmit={handleFileSubmit}
                        recordLimit={recordLimit}
                        //  We need to receive this from parent container instead of hard-coding it, e.g. security component
                         moduleName={moduleName}
                        columnHeaders={columnHeaders}
                    />
                ) : current === 2 ? (
                    <UploadProgress
                        progress={progress}
                        setProgressState={updateStatus}
                        loading={loading}
                        
                    />
                ) : (
                    <Feedback
                        setProgressState={updateStatus}
                        data={feedbackData}
                        file={uploadedFile}
                        //  We need to receive this from parent container instead of hard-coding it, e.g. security component
                         moduleName={moduleName}
                    />
                )}
            </div>
        </div>
    )
}
